import SvgIcon from '@mui/material/SvgIcon'
import styled from '@mui/material/styles/styled'
import { IconNameProp, WrappedSVGIconProps } from './types'

const HiddenTitleForWCAG = ({ name }: Required<IconNameProp>) => (
  <span style={{ visibility: 'hidden', position: 'absolute' }}>{name}</span>
)

const StyledSvgIcon = styled(SvgIcon,{
  name: 'StyledSVG', slot: 'Icon'
})<{
  height?: number | string
  width?: number | string
  htmlColor?: string
}>(({ htmlColor, height, width }) => ({
  width: width ? width : 'unset',
  height: height ? height: 'unset',
  fill: htmlColor ? `${htmlColor} !important` : 'currentColor'
}))

export const IconWrapper = ({ children, name, viewBox = '0 0 48 48', ...props }: WrappedSVGIconProps) => {
  return (
    <StyledSvgIcon viewBox={viewBox} {...props}>
      {name ? <HiddenTitleForWCAG name={name} /> : null}
      {children}
    </StyledSvgIcon>
  )
}
